import Overlay from "../Overlay";
import ActionButton from '../ActionButton'
import ConfirmationModal from '../ConfirmationModal';
import { mapGetters } from "vuex";
export default {
  name: 'eMandatePending',
  components: {
    Overlay,
    ActionButton,
    ConfirmationModal
  },
  data () {
    return {
      message: {
        value: 'Your bank account is not yet linked. We will inform you once we receive the response from the bank.',
        type: 'failure',
        fieldName: 'emandate',
        actions: [
          {
            title: "OK",
            method: () => this.goToDashboard(),
            isPrimary: true
          },
        ]
      },
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted () {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "EMANDATE_REGISTERED",
      propertyName: "RESULT",
      propertyValue: "PENDING"
    });
  },
  methods: {
    goToDashboard () {
      this.$router.push({ name: 'Dashboard' })
    },
    retryEmandate () {
      this.$router.push({ name: 'eMandate' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/eMandatePending/component.js